<template>
  <div>
    <input class="form-control" type="date" v-model="dateValue" :state="state" ref="input">
  </div>
</template>

<script>
import flatpickr from 'flatpickr'
import { DateTime } from 'luxon'
import baseInput from './_base'

export default {
  mixins: [baseInput],

  props: [],

  data() {
    return {
      dateValue: DateTime.fromISO(this.value).toISO().split('T')[0],
    }
  },

  watch: {
    dateValue(newValue) {
      this.$emit('input', newValue)
    },
  },

  mounted() {
    flatpickr(this.$refs.input, {})
  },
}
</script>

<style lang="scss">
.live-input--date {
  .form-control[readonly] {
    background-color: white;
  }
}
</style>